import { config } from '../../config/config';

const leverageMultiplier = (leverage: string) => {
    return Math.floor(parseFloat(leverage) * config.leverageMultiplier);
};

export default leverageMultiplier;
